import * as R from 'ramda';
import { ECoworkingOfferType, IJsonQuery } from './types';

import { setTerms } from './helpers';

const toggleCoworkingOfficeType =
  (jsonQuery: IJsonQuery) =>
  (coworkingOfficeType: ECoworkingOfferType): IJsonQuery => {
    if (jsonQuery.coworking_offer_type) {
      if (!jsonQuery.coworking_offer_type.value.includes(coworkingOfficeType)) {
        return setTerms('coworking_offer_type')(jsonQuery)(
          jsonQuery.coworking_offer_type.value.concat(coworkingOfficeType),
        );
      }

      return setTerms('coworking_offer_type')(jsonQuery)(
        jsonQuery.coworking_offer_type.value.filter(type => type !== coworkingOfficeType),
      );
    }

    return setTerms('coworking_offer_type')(jsonQuery)([coworkingOfficeType]);
  };

export const setCoworkingOfferType =
  (jsonQuery: IJsonQuery) =>
  (nextCoworkingOfferType: ECoworkingOfferType): IJsonQuery => {
    const clonedJsonQuery = R.clone(jsonQuery);

    switch (nextCoworkingOfferType) {
      case ECoworkingOfferType.FixedWorkSpace:
        return toggleCoworkingOfficeType(clonedJsonQuery)(ECoworkingOfferType.FixedWorkSpace);

      case ECoworkingOfferType.FlexibleOffice:
        return toggleCoworkingOfficeType(clonedJsonQuery)(ECoworkingOfferType.FlexibleOffice);

      case ECoworkingOfferType.FreeWorkSpace:
        return toggleCoworkingOfficeType(clonedJsonQuery)(ECoworkingOfferType.FreeWorkSpace);

      default:
        return clonedJsonQuery;
    }
  };
